import { AxiosPromise } from "axios";
import {AppResourceApi, SsoMember, InitDto, LoginDto, LoginResponse} from "../generated/dashboard-client";
import { dashboardApiConfig, ops } from "./config";

const api = new AppResourceApi(dashboardApiConfig);

const AppApi = {
  init(loginToken: string = ""): AxiosPromise<InitDto> {
    return api.init(ops(loginToken));
  },

  getGoogleMember(token: string): AxiosPromise<SsoMember> {
    return api.googleLogin(token);
  },

  getMicrosoftMember(token: string): AxiosPromise<SsoMember & { exists?: boolean }> {
    return api.microsoftLogin(token);
  },

  checkEmail(email: string): AxiosPromise<boolean> {
    return api.checkEmail(email, ops());
  },

  login(dto: LoginDto): AxiosPromise<LoginResponse> {
    return api.login(dto);
  }
};

export default AppApi;
